import React from 'react';
import { Box, Button, makeStyles } from '@popmenu/common-ui';
import { dishModalFullscreenBreakpoint } from '../DishModal/dishModalFullscreenBreakpoint';

type DishModalCTAProps = {
  actionText: React.ReactNode | string
  actionUrl: string
}

const useStyles = makeStyles(theme => ({
  link: {
    borderRadius: theme.spacing(4),
    display: 'block',
    fontSize: '1.125rem',
    padding: theme.spacing(2),
    textAlign: 'center',
  },
  linkContainer: {
    borderTop: `1px solid ${theme.palette.gray.main}`,
    boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12)',
    padding: theme.spacing(2),
  },
  wrapper: {
    backgroundColor: theme.palette.surface.light,
    borderRadius: theme.spacing(0, 0, 1, 1),
    [dishModalFullscreenBreakpoint]: {
      borderRadius: 0,
      bottom: 0,
      left: 0,
      position: 'fixed',
      width: '100%',
    },
    position: 'relative',
  },
}));

export const DishModalCTA = ({ actionText, actionUrl }: DishModalCTAProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.linkContainer}>
        <Button
          className={classes.link}
          color="primary"
          component="a"
          href={actionUrl}
          rel="noopener"
          role="link"
          target="_blank"
          variant="contained"
        >
          {actionText}
        </Button>
      </Box>
    </Box>
  );
};
